//region block: pre-declaration
//endregion
function canRead(_this__u8e3s4) {
  return !_this__u8e3s4.w3v();
}
//region block: exports
export {
  canRead as canRead1guo8vbveth0f,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
